<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<div class="customer-website-page-panel">
		<mat-card class="branding--customer-webpage-title-card branding--title-card">
			<mat-card-content>
				<div class="customer-ct-title-card">
					<h1>{{ customerInternet?.id ? customerInternet?.description : ("CUSTOMER_DETAILS.WEBSITE_DETAILS.TITLE_NEW_WEBSITE_FOR" | translate) + " " + customer?.name }}</h1>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="branding--customer-website-detail-card  branding--section-card">
			<mat-card-content>
				<form [formGroup]="form" class="cass-customer-website-details-form">
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.WEBSITE_DETAILS.WEBSITE_URL" | translate }}</mat-label>
						<input matInput formControlName="address" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="address"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.WEBSITE_DETAILS.DESCRIPTION" | translate }}</mat-label>
						<input matInput formControlName="description" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="description"></mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card class="branding--action-card button-container">
			<mat-card-content>
				<div class="button-container">
					<button mat-raised-button color="primary" [disabled]="!isValid()"
							(click)="modifyCustomerWebsite()">
						{{ "ACTION_BUTTON_LABELS.SAVE" | translate }}
					</button>
					<button mat-stroked-button
							(click)="closeCustomerWebsite()">
						{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}
					</button>
					<button *ngIf="customerInternet?.id" mat-stroked-button (click)='confirmDeleteCustomerWebsite()'>{{ "ACTION_BUTTON_LABELS.DELETE" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
